<template>
  <Suspense>
    <BundleStep v-if="store.steps" :currentStep="store.currentStep" :step="step" :item="step.item" :shellComponent="store.steps[0].item" :key="store.instance" :variant="step.selected?.variant" />
    <template #fallback> Loading... </template>
  </Suspense>
</template>

<script setup>
import { onMounted, computed } from 'vue';
import { useProductStore } from './Composables/Store';
import BundleStep from './BundleStep.vue';
import * as Sentry from '@sentry/vue';

const store = useProductStore();
const props = defineProps({
  terms: Object,
  handle: String,
  settings: Object,
  variant: [String, Number],
});

store.mountPromoListener();
const step = computed(() => store.getCurrentStep);

const fetchCustomSteppedCopy = () => {
  fetch('?section_id=custom-stepped-bundle-copy')
    .then((res) => res.text())
    .then((data) => {
      const html = new DOMParser().parseFromString(data, 'text/html');
      const copy = JSON.parse(html.querySelector('#shopify-section-custom-stepped-bundle-copy').textContent);
      store.$state.steppedCopy = copy;
    });
};

onMounted(async () => {
  Sentry.addIntegration(Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }));

  store.$state.isBundle = true;
  store.$state.terms = props.terms;
  store.$state.settings = props.settings;
  store.$state.steps = await store.generateSteps(props);
  fetchCustomSteppedCopy();
});
</script>
